export default {
  editTitle: 'Editar Optimización de Plan',
  newTitle: 'Nueva Optimización de Plan',
  save: 'Guardar',
  create: 'Crear',
  advancedSettings: 'Configuración Avanzada',
  planName: 'Nombre del Plan',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  budget: 'Presupuesto Total',
  budgetRestrictions: 'Restricciones de presupuesto',
  mediaTouchpoints: 'Activar/Desactivar Puntos de Contacto',
  segments: 'Segmentos',
  nameRequired: 'El nombre es requerido',
  dateRequired: 'La fecha es requerida',
  mustBeAfterStartDate: 'Debe ser posterior a la fecha de inicio',
  budgetRequired: 'El presupuesto es requerido',
  restrictionsForceOverBudget: '(Las restricciones fuerzan una inversión superior al presupuesto)',
  timeRestrictionsForceOverBudget: '(Las restricciones de tiempo fuerzan una inversión superior al presupuesto)',
  restrictionsForceUnderBudget: '(Las restricciones fuerzan una inversión inferior al presupuesto)',
  invalidRestrictionLessThanZero: '(Restricción inválida. No se puede invertir menos de cero)',
  invalidRestrictionMinOverMax: '(Restricción inválida. El mínimo no puede ser mayor que el máximo)',
  tryNewOptimizer: '¿Probar el nuevo optimizador?',
  betaUnavailableTooltip: 'El nuevo optimizador aún no está disponible para este modelo.',
  budgetAllocationRequirement: 'Requisito de Asignación de Presupuesto',
  mustSpendExactly: 'Debe gastar exactamente',
  canSpendUpTo: 'Puede gastar hasta',
  restrictions: 'Restricciones',
  externalVariablesOptional: 'Variables Externas (opcional)',
  kpiWeighting: 'Ponderación de KPI',
  kpiAutoBalance: 'Auto-Balance',
  kpiCustomWeights: 'Pesos Personalizados por KPI',
  kpiWeightsTotal: 'Total',
  kpiWeightsMustEqual100: 'Los pesos deben sumar 100%',
  kpiWeightingHint: 'Asigne pesos a cada KPI. El optimizador priorizara canales y tacticas que impulsen estos resultados. El total debe ser igual a 100%.',
  enableTime: 'Habilitar Restricciones Temporales',
  timeRestrictions: 'Restricciones de tiempo',
  selectDateRange: 'Seleccione un rango de fechas válido para configurar restricciones de tiempo',
  dateChangeBlockedByRestrictions: 'No se puede cambiar las fechas del plan. Las restricciones temporales existentes hacen referencia a meses que quedarían fuera del nuevo período. Elimine o edite esas restricciones primero.',
  feasibleChip: 'Plan factible',
  feasibility_infeasible: 'Estas restricciones no se pueden cumplir. Flexibiliza las restricciones o ajusta el presupuesto.',
  feasibility_channelMinExceedsCapacity: '{channel} no puede alcanzar su mínimo requerido en este período. Reduce su mínimo o amplía el rango de fechas.',
  feasibility_channelMinExceedsMax: '{channel} tiene un mínimo mayor que su máximo. Corrige esa restricción.',
  feasibility_sumOfMinimumsExceedsBudget: 'Los mínimos requeridos suman más que el presupuesto. Reduce algunos mínimos o aumenta el presupuesto.',
  feasibility_budgetExceedsMaxCapacity: 'El presupuesto es mayor de lo que los canales seleccionados pueden absorber en este período. Reduce el presupuesto, agrega canales o flexibiliza los máximos.',
  feasibility_groupMinExceedsCapacity: '{channels} en conjunto no pueden alcanzar su mínimo requerido en este período. Reduce ese mínimo o amplía el rango de fechas.',
  feasibility_groupMinExceedsMax: 'La restricción combinada de {channels} tiene un mínimo mayor que su máximo. Corrige esa restricción.',
  feasibility_channelConflictingRestrictions: 'Las restricciones de {channel} entran en conflicto entre sí: una exige gastar más de lo que otra permite. Corrige esas restricciones.',
  feasibility_restrictionOnUnselectedChannel: '{channels} tiene una restricción pero está desmarcado en Puntos de Contacto. Elimina la restricción o vuelve a seleccionar el canal.',
  feasibility_noChannelsSelected: 'No hay canales de medios seleccionados. Selecciona al menos un punto de contacto.'
}
